<template>
  <div class="sports-up-container">
    
    <div class="sports-up-content">
      <div v-show="!isMarqueeEditing" class="sports-list-view">
      <div class="top-container">
        <!-- 标签切换 -->
        <div class="tab-switch">
          <span :class="{active: activeTab === 'punctual'}" @click="switchTab('punctual')">准点单</span>
          <span :class="{active: activeTab === 'breaking'}" @click="switchTab('breaking')">突发单</span>
          <span :class="{active: activeTab === 'broadcast'}" @click="switchTab('broadcast')">播出单查询</span>
          <span :class="{active: activeTab === 'marquee'}" @click="switchTab('marquee')">走马灯</span>
        </div>

        <div v-if="activeTab !== 'broadcast'" class="header-actions">
          <button class="btn refresh-btn" @click="refreshData">
            <img src="@assets/img/common/reset-green.svg" alt="刷新">
            <span class="name">刷新</span>
          </button>
          <button class="btn greenBtn new-btn" @click="createNew">
            <img src="@assets/img/resources/add.svg" alt="添加">
            <span class="name">新建</span>
          </button>
        </div>
      </div>

      <div v-if="activeTab === 'broadcast'" class="broadcast-filter">
        <span class="filter-title">播出时间</span>
        <el-date-picker
          v-model="broadcastDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :clearable="false">
        </el-date-picker>
        <el-time-picker
          v-model="broadcastTime"
          format="HH:mm"
          value-format="HH:mm:ss"
          placeholder="选择时间"
          :clearable="false">
        </el-time-picker>
        <button class="broadcast-query-btn" @click="searchBroadcastList">查询</button>
      </div>
      
      
      <!-- 时间筛选 -->
      <div v-if="activeTab !== 'broadcast' && activeTab !== 'marquee'" v-click-outside="closeTimeType" class="time-filter">
        <span @click="showTimeType = !showTimeType" class="filter-label">{{timeType[timeTypeIndex].name}}<i></i></span>
        <date-picker :type="'datetime'" :format="'YYYY-MM-DD HH:mm'" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
        <ul v-show="showTimeType">
          <li v-for="(item, index) in timeType" :key="item.code" @click="changeTimeType(index)">{{item.name}}</li>
        </ul>
      </div>
      
      <!-- 数据表格 -->
      <div v-if="activeTab !== 'broadcast'" class="data-table">
        <div class="headContainer">
          <div v-show="activeTab !== 'marquee'" class="img">资讯数据图</div>
          <div class="title">{{activeTab === 'marquee' ? '任务名称' : '标题'}}</div>
          <div v-show="activeTab == 'punctual' || activeTab == 'marquee'" class="time">
            上屏时间
            <div class="sort">
              <p @click="sortList('1',2)" :class="{'up': true, on: sort_search.key == '1' && sort_search.sort_type == 2}"></p>
              <p @click="sortList('1',1)" :class="{'down': true, on: sort_search.key == '1' && sort_search.sort_type == 1}"></p>
            </div>
          </div>
          <div v-show="activeTab == 'punctual'" class="priority">优先级</div>
          <div class="creator">创建人</div>
          <div class="time">
            创建时间
            <div class="sort">
              <p @click="sortList('2',2)" :class="{'up': true, on: sort_search.key == '2' && sort_search.sort_type == 2}"></p>
              <p @click="sortList('2',1)" :class="{'down': true, on: sort_search.key == '2' && sort_search.sort_type == 1}"></p>
            </div>
          </div>
          <div class="status">状态</div>
          <div class="time">
            提交时间
            <div class="sort">
              <p @click="sortList('3',2)" :class="{'up': true, on: sort_search.key == '3' && sort_search.sort_type == 2}"></p>
              <p @click="sortList('3',1)" :class="{'down': true, on: sort_search.key == '3' && sort_search.sort_type == 1}"></p>
            </div>
          </div>
          <div class="action">操作</div>
        </div>
        <ul class="tableContainer">
          <li v-for="(item, index) in list" :key="index">
            <div v-show="activeTab !== 'marquee'" class="img">
              <img :src="item.img_url" alt="资讯图片" class="thumb-img">
            </div>
            <div class="title">{{item.title}}</div>
            <div v-show="activeTab == 'punctual' || activeTab == 'marquee'" class="time">{{item.screen_time}}</div>
            <div v-show="activeTab == 'punctual'" class="priority">{{item.priority}}</div>
            <div class="creator">{{item.creater_name}}</div>
            <div class="time">{{item.raw_add_time}}</div>
            <div :class="{status: true, error: item.status == 4, success: item.status == 2}">
              <el-tooltip :content="item.error_text" :disabled="item.status != 4" placement="bottom">
                <span>{{item.status_text}}</span>
              </el-tooltip>
            </div>
            <div class="time">{{item.submit_time}}</div>
            <div class="action">
              <p @click="check(item)" class="green">查看</p>
              <p @click="withdraw(item.id)" v-show="canShowWithdraw(item)" class="red">撤回</p>
              <p @click="retry(item.screen_time,item.id)" v-show="item.status == 4">重试</p>
            </div>
          </li>
        </ul>
      </div>

      <div v-else class="data-table broadcast-table">
        <div class="headContainer">
          <div class="index">序号</div>
          <div class="cover">播出封面</div>
          <div class="title">标题</div>
          <div class="broadcast-time">事件发生时间</div>
          <div class="broadcast-time">上屏时间</div>
        </div>
        <ul class="tableContainer">
          <li v-for="(item, index) in list" :key="item.id || index">
            <div class="index">{{(page.pageIndex - 1) * page.pageSize + index + 1}}</div>
            <div class="cover">
              <img
                v-if="item.cover_url || item.img_url"
                :src="item.cover_url || item.img_url"
                alt="播出封面"
                class="thumb-img"
                @click="openBroadcastCover(item)">
            </div>
            <div class="title">{{item.title}}</div>
            <div class="broadcast-time">{{item.event_time}}</div>
            <div class="broadcast-time">{{item.screen_time}}</div>
          </li>
        </ul>
      </div>

      <!-- 空状态 -->
      <div v-if="list.length == 0" class="empty-state">
        <i></i>
        <p>暂无数据</p>
      </div>
      
      <!-- 分页选择器 -->
      <div v-if="list.length" class="pagination-container">
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
      </div>

      <div v-show="isMarqueeEditing" :class="{'detail': marqueeMode === 'detail'}" class="marquee-edit-view">
        <div class="marquee-edit-left">
          <div class="marquee-edit-header">
            <button class="marquee-back-btn" @click="backToMarqueeList">返回</button>
            <h2>{{marqueeMode === 'detail' ? '走马灯详情' : '走马灯编辑'}}</h2>
          </div>

          <div class="marquee-title-head">
            <div class="marquee-index">序号</div>
            <div class="marquee-title">标题</div>
          </div>

          <ul v-if="marqueeEditList.length" class="marquee-title-list">
            <li
              v-for="(item, index) in marqueeEditList"
              :key="item.id || index"
              :class="{active: marqueeMode !== 'detail' && marqueeSelectedIndex === index}"
              @click="selectMarqueeItem(index)">
              <div class="marquee-index">{{index + 1}}</div>
              <div class="marquee-title">
                <div v-if="marqueeMode !== 'detail' && marqueeEditingIndex === index" class="textArea">
                  <textarea
                    v-if="marqueeMode !== 'detail' && marqueeEditingIndex === index"
                    v-model="marqueeEditDraft"
                    maxlength="40"
                    @click.stop
                    @keyup.enter="saveMarqueeItem(index)"
                    @keyup.esc="cancelMarqueeItemEdit">
                  </textarea>
                  <span>{{marqueeEditDraft.length}}/40</span>
                </div>
                <div @click="saveMarqueeItem(index)" v-if="marqueeMode !== 'detail' && marqueeEditingIndex === index" class="confirmBtn">确认</div>
                <span v-if="marqueeMode === 'detail' || marqueeEditingIndex != index">{{item.title}}</span>
              </div>
              <div v-if="marqueeMode !== 'detail' && marqueeEditingIndex != index && !marqueePreviewMode" class="marquee-row-actions">
                <button title="编辑" @click.stop="startEditMarqueeItem(index)"></button>
                <button title="删除" @click.stop="removeMarqueeItem(index)"></button>
              </div>
            </li>
          </ul>

          <div v-if="marqueeEditList.length == 0" class="marquee-empty">
            <i></i>
            <p>暂无内容</p>
          </div>
        </div>

        <div class="marquee-edit-right">
          <template v-if="marqueeMode !== 'detail'">
          <template v-if="marqueePreviewMode">
            <div class="marquee-preview-notice">
              <i class="marquee-preview-notice-icon"></i>
              <p>该预览仅展示文字，实际底版配色、动态效果以上屏为准</p>
            </div>
            <button class="marquee-submit-btn" @click="confirmMarqueeSubmit">确认</button>
            <!-- <button class="marquee-preview-back-btn" @click="cancelMarqueePreview">返回编辑</button> -->
          </template>
          <template v-else>
            <div class="marquee-form-block">
              <div class="marquee-form-label">上屏时间</div>
              <el-date-picker
                v-model="marqueeScreenDate"
                class="marquee-date-picker"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :clearable="false">
              </el-date-picker>
              <el-time-picker
                v-model="marqueeScreenTime"
                class="marquee-time-picker"
                format="HH:mm"
                value-format="HH:mm:ss"
                placeholder="选择时间"
                :clearable="false">
              </el-time-picker>
            </div>
            <button class="marquee-submit-btn" @click="submitMarquee">提交</button>
          </template>
          </template>

          <div v-else class="marquee-detail-panel">
            <div class="marquee-detail-summary">
              <div class="marquee-detail-row highlight">
                <span>上屏时间</span>
                <strong>{{marqueeDetail.screen_time || '--'}}</strong>
              </div>
              <!-- <div class="marquee-detail-row highlight">
                <span>表头信息</span>
                <strong>{{marqueeDetail.header_info || marqueeDetail.title || marqueeDetail.task_name || '--'}}</strong>
              </div> -->
            </div>

            <div class="marquee-detail-section-title">其他信息</div>
            <div class="marquee-detail-card">
              <div class="marquee-detail-row">
                <span>创建时间:</span>
                <strong>{{marqueeDetail.raw_add_time || '--'}}</strong>
              </div>
              <div class="marquee-detail-row">
                <span>创建人:</span>
                <strong>{{marqueeDetail.creater_name || '--'}}</strong>
              </div>
              <div class="marquee-detail-row">
                <span>提交时间:</span>
                <strong>{{marqueeDetail.submit_time || '--'}}</strong>
              </div>
              <div class="marquee-detail-row">
                <span>任务状态:</span>
                <strong class="state">{{marqueeDetail.status_text || '--'}}</strong>
              </div>
              <div class="marquee-detail-row">
                <span>撤回时间:</span>
                <strong>{{marqueeDetail.withdrawn_at || marqueeDetail.withdraw_time || marqueeDetail.revoke_time || marqueeDetail.cancel_time || '--'}}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showMarqueeRangeDialog" class="marquee-range-mask">
      <div class="marquee-range-dialog">
        <div class="marquee-range-title">
          请选择<span>准点单上屏时间</span>范围
        </div>
        <div class="marquee-range-form">
          <span class="marquee-range-prefix">前</span>
          <el-select
            v-model="marqueeRangeHours"
            class="marquee-range-select"
            popper-class="marquee-range-select-popper"
            :clearable="false">
            <el-option
              v-for="item in marqueeRangeOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <span class="marquee-range-unit">小时</span>
        </div>
        <div class="marquee-range-actions">
          <button class="marquee-range-btn confirm" @click="confirmMarqueeRange">确定</button>
          <button class="marquee-range-btn cancel" @click="cancelMarqueeRange">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pages from "@components/pages";
import { apis } from "@common/config";
import common from "@common/common";
import DatePicker from 'vue2-datepicker'
import vClickOutside from "v-click-outside";

export default {
  name: "SportsUp",
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    pages,
    DatePicker
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n, o) {
        if (!n || !n.length) {
          this.start = ''
          this.end = ''
          return
        }

        this.start = common.stampToTime(n[0])
        this.end = common.stampToTime(n[1])

        this.page.pageIndex = 1
        this.getList()
      }
    }
  },
  data() {
    return {
      datePicker: '',
      start: '',
      end: '',
      activeTab: "punctual",
      dataList: [],
      page: {
        pageCount: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      searchOptions: {},
      list: [],
      broadcastDate: '',
      broadcastTime: '',
      controller: null,
      consultConfig: {},
      showTimeType: false,
      timeType: [
        {
          name: '上屏时间',
          code: '1'
        },
        {
          name: '创建时间',
          code: '2'
        },
        {
          name: '提交时间',
          code: '3'
        }
      ],
      timeTypeIndex: 0,
      sort_search: {
        key: 1,
        sort_type: 1
      },
      showMarqueeRangeDialog: false,
      marqueeRangeHours: 12,
      marqueeRangeOptions: [12, 24],
      isMarqueeEditing: false,
      marqueeEditList: [],
      marqueeSelectedIndex: -1,
      marqueeEditingIndex: -1,
      marqueeEditDraft: '',
      marqueeScreenDate: '',
      marqueeScreenTime: '',
      marqueeHeader: '',
      marqueeMode: 'edit',
      marqueeDetail: {},
      marqueePreviewMode: false,
      marqueePreviewAnimating: false
    };
  },
  mounted() {
    this.setDefaultBroadcastTime()
    this.getConsultConfig()
    this.getList()
    // this.$newLibraryMaterial()
    // this.$CreateTimeOutList()
    // this.$timeOutListDetail()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeRouteLeave(to, from, next) {
    if (this.isMarqueeEditing && this.marqueeMode != 'detail') {
      this.$confirm('当前正在编辑走马灯，确定要离开吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
  methods: {
    handleBeforeUnload(e) {
      if (this.isMarqueeEditing) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
    retry(screenTime,id) {
      const now = new Date();
      const screenDate = new Date(screenTime);
      const diffMs = screenDate - now;
      const diffMins = diffMs / (1000 * 60);

      console.log(diffMins)

      if (this.activeTab === 'marquee') {
        if (diffMins <= 5) {
          this.$changeTime({
            id: id,
            api: apis.consultLanternCarouselScreenTime
          }).then(res => {
            if(res){
              this.getList();
            }
          })
          return
        }

        common.myFetch(apis.consultLanternCarouselRetry, {id: id}).then(res => {
          if (res) {
            this.$toast('重试成功');
            this.getList();
          }
        });
        return
      }
      
      if (diffMins <= 5) {
        this.$changeTime({id: id}).then(res => {
          if(res){
            this.getList();
          }
        })
      }else{
        common.myFetch(apis.consultRetry, {id: id, consult_type: this.activeTab === 'punctual' ? 1 : this.activeTab === 'breaking' ? 2 : 3}).then(res => {
          if (res) {
            this.$toast('重试成功');
            this.getList();
          }
        });
      }
    },
    withdraw(id) {
      const url = this.activeTab === 'marquee'
        ? apis.consultLanternCarouselWithdraw
        : apis.consultWithdraw

      common.myFetch(url, {id: id}).then(res => {
        if (res) {
          this.$toast('撤回成功')
          this.getList()
        }
      })
    },
    check(item) {
      if (this.activeTab === 'marquee') {
        this.openMarqueeDetail(item)
        return
      }

      item.activeTab = this.activeTab
      this.$timeOutListDetail(item)
    },
    canShowWithdraw(item) {
      if (this.activeTab === 'marquee') {
        return item.status == 2
      }

      return this.activeTab === 'punctual'
    },
    sortList(type, order) {
      this.sort_search.key = type
      this.sort_search.sort_type = order
      this.page.pageIndex = 1
      this.getList()
    },
    changeTimeType(index) {
      this.timeTypeIndex = index
      this.showTimeType = false
      this.page.pageIndex = 1
      this.getList()
    },
    closeTimeType() {
      this.showTimeType = false
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    setDefaultBroadcastTime() {
      const now = new Date()
      const minute = now.getMinutes()
      const targetDate = new Date(now)

      if (minute > 15 && minute <= 44) {
        targetDate.setMinutes(45, 0, 0)
      } else {
        if (minute > 44) {
          targetDate.setHours(targetDate.getHours() + 1)
        }

        targetDate.setMinutes(15, 0, 0)
      }

      const hour = String(targetDate.getHours()).padStart(2, '0')
      const targetMinute = String(targetDate.getMinutes()).padStart(2, '0')

      this.broadcastDate = this.formatDate(targetDate)
      this.broadcastTime = `${hour}:${targetMinute}:00`
    },
    getBroadcastSearchParams() {
      return {
        screen_time: `${this.broadcastDate} ${this.broadcastTime}`
      }
    },
    openBroadcastCover(item) {
      const url = item.cover_url || item.img_url

      if (!url) {
        return
      }

      this.$viewer([], {
        url: url,
        downloadUrl: url,
        idstring: item.id || '',
        type: 1
      }, 'img')
    },
    searchBroadcastList() {
      this.page.pageIndex = 1
      this.getBroadcastList()
    },
    getBroadcastList() {
      const data = {
        ...this.getBroadcastSearchParams(),
        page: this.page.pageIndex,
        page_size: this.page.pageSize
      }

      common.myFetch(apis.consultBroadcastSearch, data).then(res => {
        const list = res && Array.isArray(res.list) ? res.list : []
        const pageInfo = res && res.page ? res.page : {}
        const pageSize = Number(pageInfo.pagesize || pageInfo.page_size || this.page.pageSize)
        const total = Number(pageInfo.row_count || list.length || 0)
        const pageCount = Number(pageInfo.page_count || common.calculatePage(total, pageSize))

        this.list = list.map(item => {
          return Object.assign({}, item, {
            cover_url: item.cover_url || item.img_url,
            event_time: item.event_time || item.happen_time
          })
        })
        this.$set(this.page, "pageSize", pageSize)
        this.$set(this.page, "pageIndex", Number(pageInfo.page || this.page.pageIndex))
        this.$set(this.page, "pageCount", pageCount)
        this.$set(this.page, "total", total)
      })
    },
    getLanternCarouselList() {
      const sortSearch = {
        key: Number(this.sort_search.key),
        sort_type: Number(this.sort_search.sort_type)
      }
      const data = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        sort_search: JSON.stringify(sortSearch)
      }

      this.list = []
      common.myFetch(apis.consultLanternCarouselList, data).then(res => {
        const list = res && Array.isArray(res.list) ? res.list : []
        const pageInfo = res && res.page ? res.page : {}
        const pageSize = Number(pageInfo.pagesize || this.page.pageSize)
        const total = Number(pageInfo.row_count || list.length || 0)
        const pageCount = Number(pageInfo.page_count || common.calculatePage(total, pageSize))

        this.list = list.map(item => {
          return Object.assign({}, item, {
            title: item.title || item.task_name
          })
        })
        this.$set(this.page, "pageSize", pageSize)
        this.$set(this.page, "pageIndex", Number(pageInfo.page || this.page.pageIndex))
        this.$set(this.page, "pageCount", pageCount)
        this.$set(this.page, "total", total)
      })
    },
    getConsultConfig() {
      let info = {
        consult_type: this.activeTab === 'punctual' ? 1 : this.activeTab === 'breaking' ? 2 : ''
      }
      common.myFetch(apis.consultConfig, info).then(res => {
        if (res) {
          this.consultConfig = res
          if (res.lantern_carousel_time) {
            this.marqueeRangeOptions = res.lantern_carousel_time
          }
        }
      })
    },
    getList() {
      if (this.activeTab === 'broadcast') {
        this.getBroadcastList()
        return
      }

      if (this.activeTab === 'marquee') {
        this.getLanternCarouselList()
        return
      }

      if (this.controller) {
        this.controller.abort(); // 终止之前的请求
      }

      this.controller = new AbortController(); // 创建新的 AbortController
      const signal = this.controller.signal; // 获取信号

      this.list = [];

      let data = {
        search_option: "",
        key_words: "",
        start_time: this.start,
        end_time: this.end,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        time_search_option: this.timeType[this.timeTypeIndex].code,
        sort_search: JSON.stringify(this.sort_search),
        consult_type: this.activeTab === 'punctual' ? 1 : this.activeTab === 'breaking' ? 2 : 3
      };

       Object.assign(data, this.searchOptions);

      common.myFetch(apis.consultList, {data: data,signal: signal}).then(res => {
        if (res) {
          console.log(res)

          this.list = res.list;

          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
        }
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    switchTab(tab) {
      if (tab === this.activeTab) {
        return
      }

      this.list = []

      this.isMarqueeEditing = false

      if (tab === 'broadcast') {
        this.activeTab = tab
        this.datePicker = ''
        this.searchOptions = {}
        this.page.pageIndex = 1
        this.getBroadcastList()
        return
      }

      this.activeTab = tab
      this.datePicker = ''
      this.timeTypeIndex = 0
      this.page.pageIndex = 1

      if(tab === 'punctual' || tab === 'marquee'){
        this.timeType = [
          {
            name: '上屏时间',
            code: '1'
          },
          {
            name: '创建时间',
            code: '2'
          },
          {
            name: '提交时间',
            code: '3'
          }
        ]
        this.sort_search.key = '1'
        this.sort_search.sort_type = 1
      }else{
        this.timeType = [
          {
            name: '创建时间',
            code: '2'
          },
          {
            name: '提交时间',
            code: '3'
          }
        ]
        this.sort_search.key = '2'
        this.sort_search.sort_type = 1
      }
      this.getConsultConfig();
      this.getList();
    },
    refreshData() {
      this.getList();
    },
    createNew() {
      // 新建功能
      if (this.activeTab === 'marquee') {
        this.showMarqueeRangeDialog = true
        return
      }

      this.openNewLibraryMaterial()
    },
    openNewLibraryMaterial(extraConfig = {}) {
      const config = Object.assign({}, this.consultConfig, extraConfig, {
        activeTab: this.activeTab,
        freshFn: this.refreshData
      })

      this.$newLibraryMaterial(config, this.refreshData)
    },
    confirmMarqueeRange() {
      this.showMarqueeRangeDialog = false
      this.openMarqueeEdit()
    },
    cancelMarqueeRange() {
      this.showMarqueeRangeDialog = false
    },
    openMarqueeEdit() {
      this.marqueeMode = 'edit'
      this.isMarqueeEditing = true
      this.marqueeDetail = {}
      this.marqueeHeader = ''
      this.marqueePreviewMode = false
      this.marqueePreviewAnimating = false
      this.setDefaultMarqueeScreenTime()
      this.marqueeSelectedIndex = -1
      this.marqueeEditingIndex = -1
      this.marqueeEditDraft = ''
      this.getMarqueeEditList()
    },
    openMarqueeDetail(item) {
      this.marqueeMode = 'detail'
      this.isMarqueeEditing = true
      this.marqueeDetail = Object.assign({}, item)
      this.marqueeEditList = []
      this.marqueeSelectedIndex = -1
      this.marqueeEditingIndex = -1
      this.marqueeEditDraft = ''

      common.myFetch(apis.consultLanternCarouselDetail, {id: item.id}).then(res => {
        const list = res && Array.isArray(res.list) ? res.list : []
        const detail = res && res.result ? res.result : {}

        this.marqueeDetail = Object.assign({}, item, detail)
        this.marqueeEditList = this.normalizeMarqueeTitleList(list)
      })
    },
    normalizeMarqueeTitleList(list) {
      return list.map((item, index) => {
        if (typeof item === 'string') {
          return {
            id: `detail-${index + 1}`,
            title: item
          }
        }

        return Object.assign({}, item, {
          title: item.title || item.task_name || ''
        })
      })
    },
    backToMarqueeList() {
      if(this.marqueePreviewMode){
        this.cancelMarqueePreview()
      }else{
        this.isMarqueeEditing = false
        this.marqueeMode = 'edit'
        this.marqueeDetail = {}
        this.marqueePreviewMode = false
        this.marqueePreviewAnimating = false
        this.marqueeSelectedIndex = -1
        this.marqueeEditingIndex = -1
        this.marqueeEditDraft = ''
        this.getList()
      }
    },
    setDefaultMarqueeScreenTime() {
      const now = new Date()
      const target = new Date(now)

      target.setHours(19, 0, 0, 0)

      if (now.getTime() > target.getTime()) {
        target.setDate(target.getDate() + 1)
      }

      this.marqueeScreenDate = this.formatDate(target)
      this.marqueeScreenTime = '19:00:00'
    },
    getMarqueeEditList() {
      this.marqueeEditList = []
      this.marqueeSelectedIndex = -1

      common.myFetch(apis.consultLanternCarouselAddDetail, {
        previous_hour: this.marqueeRangeHours
      }).then(res => {
        const list = res && Array.isArray(res.list) ? res.list : []

        this.marqueeEditList = list.map(item => {
          return Object.assign({}, item, {
            title: item.title || item.task_name || ""
          })
        })
        this.marqueeSelectedIndex = this.marqueeEditList.length ? 0 : -1
      })
    },
    selectMarqueeItem(index) {
      this.marqueeSelectedIndex = index
    },
    startEditMarqueeItem(index) {
      this.marqueeSelectedIndex = index
      this.marqueeEditingIndex = index
      this.marqueeEditDraft = this.marqueeEditList[index].title
    },
    saveMarqueeItem(index) {
      const title = this.marqueeEditDraft.trim()

      if (!title) {
        this.$toast('标题不能为空')
        return
      }

      this.$set(this.marqueeEditList, index, Object.assign({}, this.marqueeEditList[index], {
        title: title
      }))
      this.cancelMarqueeItemEdit()
    },
    cancelMarqueeItemEdit() {
      this.marqueeEditingIndex = -1
      this.marqueeEditDraft = ''
    },
    removeMarqueeItem(index) {
      this.marqueeEditList.splice(index, 1)

      if (this.marqueeEditingIndex === index) {
        this.cancelMarqueeItemEdit()
      }

      if (!this.marqueeEditList.length) {
        this.marqueeSelectedIndex = -1
        return
      }

      this.marqueeSelectedIndex = Math.min(index, this.marqueeEditList.length - 1)
    },
    getMarqueeScreenTime() {
      if (!this.marqueeScreenDate || !this.marqueeScreenTime) {
        return ''
      }

      return `${this.marqueeScreenDate} ${this.marqueeScreenTime}`
    },
    hasMarqueeSpecialSymbol(value) {
      return !/^[\u4e00-\u9fa5A-Za-z0-9\s，。、“”‘’：；？！《》【】（）()；:;,.!?-]+$/.test(value)
    },
    getMarqueeTitleContent() {
      return this.marqueeEditList
        .map(item => {
          return {
            id: item.id,
            title: (item.title || '').trim()
          }
        })
        .filter(item => item.title)
    },
    submitMarquee() {
      const screenTime = this.getMarqueeScreenTime()
      const headerInfo = this.marqueeHeader.trim()
      const titleContent = this.getMarqueeTitleContent()

      if (!titleContent.length) {
        this.$toast('序列内容不能为空')
        return
      }

      if (!screenTime) {
        this.$toast('上屏时间不能为空')
        return
      }

      const screenTimestamp = new Date(screenTime.replace(/-/g, '/')).getTime()
      if (!screenTimestamp || screenTimestamp - Date.now() <= 5 * 60 * 1000) {
        this.$toast('上屏时间需晚于当前时间5分钟')
        return
      }

      // const hasSpecialSymbol = titleContent.some(item => this.hasMarqueeSpecialSymbol(item.title))
      // if (hasSpecialSymbol) {
      //   this.$toast('序列内容不能包含特殊符号')
      //   return
      // }

      this.marqueePreviewMode = true
      this.marqueePreviewAnimating = false
      this.$nextTick(() => {
        this.marqueePreviewAnimating = true
      })
    },
    cancelMarqueePreview() {
      this.marqueePreviewMode = false
      this.marqueePreviewAnimating = false
    },
    confirmMarqueeSubmit() {
      const screenTime = this.getMarqueeScreenTime()
      const headerInfo = this.marqueeHeader.trim()
      const titleContent = this.getMarqueeTitleContent()

      const data = {
        title_content: JSON.stringify(titleContent),
        screen_time: screenTime,
        header_info: headerInfo
      }

      common.myFetch(apis.consultLanternCarouselPush, data).then(res => {
        if (res) {
          this.$toast('新建成功')
          this.marqueePreviewMode = false;
          this.backToMarqueeList()
        }
      })
    },
    viewItem(item) {
      // 查看详情
      console.log("View item:", item);
    },
    withdrawItem(item) {
      // 撤回操作
      console.log("Withdraw item:", item);
    },
    retryItem(item) {
      // 重试操作
      console.log("Retry item:", item);
    }
  }
};
</script>

<style lang="less" scoped>
.sports-up-container {
  padding: 20px;
  flex: 1;
  min-width: 0;
  
  .sports-up-content {
    background-color: #fff;
    border-radius: 4px;
    height: 100%;

    .top-container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      padding: 20px 30px 0;
      box-sizing: border-box;

      .header-actions {
        display: flex;
        gap: 15px;
        
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #41B48C;
          cursor: pointer;
          user-select: none;
          
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
          
          .name {
            font-size: 14px;
          }
          
          &:active {
            background-color: rgba(0, 0, 0, 0.2);
          }
          
          &:hover {
            position: relative;
            
            &::after {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              border-radius: inherit;
              background-color: rgba(0, 0, 0, 0.05);
            }
          }
        }
        
        .refresh-btn {
          border: 1px solid #41B48C;
          background-color: #fff;
          color: #41B48C;
          box-sizing: border-box;
        }
        
        .greenBtn {
          background-color: #41b48c;
          color: #fff;
          border: none;
        }
      }

    }
    
    .tab-switch {
      display: flex;
      margin-bottom: 26px;
      
      span {
        font-weight: bold;
        font-size: 18px;
        color: #B9C3C3;
        line-height: 25px;
        cursor: pointer;
        margin-right: 40px;
        
        &.active {
          position: relative;
          color: #41B48C;
          border-bottom-color: #41B48C;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -5px;
            width: 100%;
            height: 2px;
            background-color: #41B48C;
            border-radius: 2px;
          }
        }
      }
    }
    
    .broadcast-filter {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 20px;
      padding: 0 30px;
      box-sizing: border-box;

      .filter-title {
        font-weight: bold;
        font-size: 13px;
        color: #41B48C;
        margin-right: 20px;
      }

      .el-date-editor {
        width: 150px;
        height: 30px;
      }

      .broadcast-query-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 59px;
        height: 30px;
        background: #41B48C;
        border-radius: 4px;
        border: none;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
        user-select: none;

        &:active {
          background-color: #359a77;
        }
      }
    }

    .time-filter {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 30px;
      box-sizing: border-box;

      ul {
        position: absolute;
        top: 28px;
        left: 20px;
        display: flex;
        flex-direction: column;
        width: 88px;
        background: #FFFFFF;
        box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
        border-radius: 4px;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 30px;
          font-weight: 500;
          font-size: 12px;
          color: #050F0F;
          user-select: none;
          cursor: pointer;

          &.on {
            background: rgba(65,180,140,0.15);
          }

          &:hover {
            background: rgba(65,180,140,0.15);
          }
        }
      }
      
      .filter-label {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #00B789;
        margin-right: 20px;
        user-select: none;
        cursor: pointer;

        i {
          display: block;
          width: 10px;
          height: 6px;
          margin-left: 10px;
          background: url("../../assets/img/common/arrow.png") no-repeat;
          background-position: center center;
          background-size: 100% 100%;
        }
      }
      
      .date-input {
        padding: 6px 10px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
      }
      
      .filter-separator {
        color: #999;
      }
    }
    
    .data-table {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: 30px;

      .headContainer {
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        background: #F9F9F9;
        box-shadow: 0px 0px 10px 0px rgba(6,21,50,0.05);
        padding: 0 30px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 14px;
        color: #829191;

        .img {
          width: 98px;
        }

        .title {
          flex: 1;
          min-width: 0;
          margin-right: 10px;
        }

        .time {
          display: flex;
          align-items: center;
          width: 78px;
          margin-right: 32px;

          .sort {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 6px;

            .up {
              display: block;
              width: 8px;
              height: 4px;
              background: url('../../assets/img/common/arrowIcon.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              transform: rotate(180deg);
              user-select: none;
              cursor: pointer;
              margin-bottom: 2px;

              &.on {
                display: block;
                width: 8px;
                height: 4px;
                background: url('../../assets/img/common/arrowIconOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                transform: rotate(0deg);
                user-select: none;
                cursor: pointer;
                margin-bottom: 2px;
              }
            }

            .down {
              display: block;
              width: 8px;
              height: 4px;
              background: url('../../assets/img/common/arrowIcon.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              user-select: none;
              cursor: pointer;

              &.on {
                display: block;
                width: 8px;
                height: 4px;
                background: url('../../assets/img/common/arrowIconOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                transform: rotate(180deg);
                user-select: none;
                cursor: pointer;
                margin-bottom: 2px;
              }
            }
          }
        }

        .priority {
          width: 42px;
          margin-right: 40px;
          text-align: center;
        }

        .creator {
          width: 42px;
          margin-right: 40px;
          text-align: center;
        }

        .status {
          width: 56px;
          margin-right: 40px;
          text-align: center;
        }

        .action {
          width: 90px;
        }
      }

      .tableContainer {
        display: flex;
        flex-direction: column;
        width: 100%;

        li {
          display: flex;
          align-items: center;
          width: 100%;
          min-height: 88px;
          font-weight: 400;
          font-size: 14px;
          color: #050F0F;
          padding: 10px 30px;
          box-sizing: border-box;

          &:hover {
            background: rgba(185,195,195,0.15);
          }

          .img {
            width: 98px;

            img {
              width: 68px;
              height: 68px;
              border-radius: 4px;
              object-fit: contain;
            }
          }

          .title {
            flex: 1;
            min-width: 0;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-right: 10px;
            font-size: 16px;
            line-height: 22px;
          }

          .time {
            display: flex;
            align-items: center;
            width: 78px;
            margin-right: 32px;
            font-size: 14px;
            color: #B9C3C3;
          }

          .priority {
            width: 42px;
            margin-right: 40px;
            text-align: center;
          }

          .creator {
            width: 42px;
            margin-right: 40px;
            text-align: center;
          }

          .status {
            width: 56px;
            margin-right: 40px;
            text-align: center;
            color: #B9C3C3;

            &.error {
              color: #FF555A;
            }

            &.success {
              color: #41B48C;
            }
          }

          .action {
            display: flex;
            align-items: center;
            min-width: 90px;

            p {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 40px;
              height: 30px;
              background: #FFFFFF;
              box-shadow: 2px 2px 8px 0px rgba(0,0,0,0.1);
              border-radius: 4px;
              font-weight: bold;
              font-size: 14px;
              color: #829191;
              user-select: none;
              cursor: pointer;
              margin-left: 10px;

              &:active {
                background-color: rgba(0, 0, 0, 0.2);
              }
              
              &:hover {
                position: relative;
                
                &::after {
                  content: '';
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  left: 0;
                  top: 0;
                  border-radius: inherit;
                  background-color: rgba(0, 0, 0, 0.05);
                }
              }

              &:nth-last-of-type(1) {
                margin-right: 0;
              }

              &.green {
                background: #41B48C;
                color: #FFFFFF;
                margin-left: 0px;
              }

              &.red {
                color: #FF555A;
                margin-left: 10px;
              }
            }
          }
        }
      }

      &.broadcast-table {
        .headContainer {
          .index {
            width: 52px;
            margin-right: 24px;
            text-align: center;
          }

          .cover {
            width: 98px;
            margin-right: 24px;
          }

          .broadcast-time {
            width: 150px;
            margin-left: 32px;
          }
        }

        .tableContainer {
          li {
            .index {
              width: 52px;
              margin-right: 24px;
              text-align: center;
              color: #829191;
            }

            .cover {
              width: 98px;
              margin-right: 24px;

              img {
                width: 68px;
                height: 68px;
                border-radius: 4px;
                object-fit: contain;
                cursor: pointer;
              }
            }

            .broadcast-time {
              width: 150px;
              margin-left: 32px;
              color: #B9C3C3;
            }
          }
        }
      }
    }

    .empty-state {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: #999;
      box-sizing: border-box;
      min-height: 460px;

      i {
        display: block;
        width: 94px;
        height: 70px;
        background: url('../../assets/img/common/empty.svg') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-bottom: 20px;
      }
    }
    
    .pagination-container {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .sports-list-view {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .marquee-edit-view {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 647px;
    background: #F3F7F7;
    border-radius: 4px;
    overflow: hidden;

    &.detail {
      .marquee-title-list li {
        cursor: default;

        &:hover {
          background: transparent;

          .marquee-title {
            color: #050F0F;
          }
        }
      }
    }
  }

  .marquee-edit-left {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    background: #F9F9F9;
    box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
    border-radius: 4px;
  }

  .marquee-edit-header {
    display: flex;
    align-items: center;
    height: 66px;
    padding: 0 30px;
    box-sizing: border-box;

    h2 {
      margin: 0 0 0 20px;
      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      color: #050F0F;
    }
  }

  .marquee-back-btn {
    width: 58px;
    height: 30px;
    border: none;
    border-radius: 4px;
    background: #F3F5F5;
    font-size: 14px;
    color: #425252;
    cursor: pointer;
    user-select: none;

    &:active {
      background: #E5EAEA;
    }
  }

  .marquee-title-head {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 20px 0 40px;
    background: #F9F9F9;
    box-shadow: 0 0 10px 0 rgba(6, 21, 50, 0.05);
    box-sizing: border-box;
    font-weight: bold;
    font-size: 14px;
    color: #829191;
  }

  .marquee-index {
    width: 28px;
    margin-right: 30px;
    text-align: center;
    flex-shrink: 0;
  }

  .marquee-title {
    flex: 1;
    min-width: 0;
  }

  .marquee-title-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
    margin: 0;

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-thumb {
      border: 4px solid #FFFFFF;
      border-radius: 8px;
      background: #D3D8D8;
    }

    li {
      display: flex;
      align-items: center;
      min-height: 42px;
      padding: 0 20px 0 40px;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 22px;
      color: #050F0F;
      cursor: pointer;

      &:hover,
      &.active {
        background: #F4F6F6;

        .marquee-title {
          color: #41B48C;
        }

        .marquee-row-actions {
          opacity: 1;
          pointer-events: auto;
        }
      }

      .marquee-title {
        display: flex !important;
        align-items: flex-end;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        input {
          width: 100%;
          height: 30px;
          padding: 0 8px;
          border: 1px solid #41B48C;
          border-radius: 4px;
          box-sizing: border-box;
          background: #FFFFFF;
          font-size: 15px;
          color: #050F0F;
          outline: none;
        }

        .textArea {
          position: relative;
          flex: 1;
          min-width: 0;

          textarea {
            width: 100%;
            height: 74px;
            background: rgba(185,195,195,0.2);
            resize: none;
            padding: 10px 14px;
            box-sizing: border-box;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #050F0F;
            line-height: 22px;
          }

          span {
            position: absolute;
            bottom: 6px;
            right: 14px;
            font-weight: 500;
            font-size: 14px;
            color: #B9C3C3;
            line-height: 20px;
          }
        }

        .confirmBtn {
          font-weight: bold;
          font-size: 14px;
          color: #41B48C;
          line-height: 20px;
          margin-left: 14px;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }

  .marquee-row-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 70px;
    margin-left: 20px;
    opacity: 0;
    pointer-events: none;
    flex-shrink: 0;

    button {
      width: 22px;
      height: 22px;
      border: none;
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 19px 22px;
      cursor: pointer;

      &:first-child {
        margin-right: 20px;
        background-image: url('../../assets/img/material/editIcon.svg');
      }

      &:last-child {
        background-size: 20px 20px;
        background-image: url('../../assets/img/material/delIcon.svg');
      }
    }
  }

  .marquee-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #999;
    box-sizing: border-box;
    min-height: 460px;

    i {
      display: block;
      width: 94px;
      height: 70px;
      background: url('../../assets/img/common/empty.svg') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      margin-bottom: 20px;
    }
  }

  .marquee-edit-right {
    position: relative;
    width: 336px;
    padding: 36px 30px;
    box-sizing: border-box;
    flex-shrink: 0;
    background: #F3F5F6;
  }

  .marquee-form-block {
    margin-bottom: 30px;
  }

  .marquee-form-label {
    margin-bottom: 14px;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #182626;
  }

  .marquee-date-picker,
  .marquee-time-picker {
    display: block;
    width: 276px;
    height: 30px;
    margin-bottom: 10px;

    /deep/ .el-input__inner {
      height: 30px;
      border: none;
      border-radius: 2px;
      background: #E8EEEE;
      font-size: 14px;
      line-height: 30px;
      color: #050F0F;

      &::placeholder {
        color: #B9C3C3;
      }
    }

    /deep/ .el-input__icon {
      line-height: 30px;
      color: #9EADAD;
    }
  }

  .marquee-header-input {
    position: relative;
    width: 276px;
    height: 30px;

    input {
      width: 100%;
      height: 30px;
      padding: 0 50px 0 14px;
      border: none;
      border-radius: 2px;
      background: #E8EEEE;
      box-sizing: border-box;
      font-size: 14px;
      color: #050F0F;
      outline: none;

      &::placeholder {
        color: #B9C3C3;
      }
    }

    span {
      position: absolute;
      top: 0;
      right: 14px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      color: #B9C3C3;
    }
  }

  .marquee-submit-btn {
    position: absolute;
    left: 108px;
    bottom: 48px;
    width: 120px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background: #41B48C;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
    user-select: none;

    &:active {
      background: #359a77;
    }
  }

  .marquee-preview-back-btn {
    position: absolute;
    left: 108px;
    bottom: 10px;
    width: 120px;
    height: 32px;
    border: 1px solid #B9C3C3;
    border-radius: 4px;
    background: #FFFFFF;
    font-size: 14px;
    color: #829191;
    cursor: pointer;
    user-select: none;

    &:active {
      background: #F3F5F5;
    }
  }

  .marquee-preview-notice {
    display: flex;
    align-items: baseline;

    .marquee-preview-notice-icon {
      width: 14px;
      min-width: 14px;
      height: 14px;
      margin-right: 8px;
      background: url('../../assets/img/common/alert.png') no-repeat center;
      background-size: 100% 100%;
    }

    p {
      font-size: 13px;
      line-height: 20px;
      color: #829191;
    }
  }

  .marquee-preview-content {
    width: 276px;
    height: 160px;
    margin-bottom: 20px;
    background: #1A1A2E;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }

  .marquee-preview-scroll {
    display: flex;
    align-items: center;
    height: 100%;
    white-space: nowrap;

    &.marquee-preview-scroll-animate {
      animation: marqueeScrollText 12s linear infinite;
    }
  }

  .marquee-preview-text {
    display: inline-block;
    padding: 0 40px;
    font-size: 18px;
    color: #FFFFFF;
    white-space: nowrap;
  }

  .marquee-preview-time {
    margin-bottom: 16px;
    font-size: 14px;
    color: #829191;
    line-height: 20px;
  }

  @keyframes marqueeScrollText {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  .marquee-detail-panel {
    font-size: 14px;
    color: #050F0F;
  }

  .marquee-detail-summary {
    padding-bottom: 18px;
    border-bottom: 1px solid #DDE4E4;
    margin-bottom: 26px;
  }

  .marquee-detail-section-title {
    margin-bottom: 14px;
    font-size: 14px;
    line-height: 20px;
    color: #182626;
  }

  .marquee-detail-card {
    padding: 16px 14px;
    background: #E8EEEE;
    box-sizing: border-box;
  }

  .marquee-detail-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 24px;
    margin-bottom: 12px;
    line-height: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    span {
      flex-shrink: 0;
      color: #829191;
    }

    strong {
      max-width: 168px;
      margin-left: 16px;
      font-weight: 400;
      color: #050F0F;
      text-align: right;
      word-break: break-all;

      &.state {
        color: #41B48C;
      }
    }

    &.highlight {
      align-items: center;

      span {
        font-weight: bold;
        color: #41B48C;
      }
    }
  }

  .marquee-range-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1002;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(47, 55, 64, 0.36);
  }

  .marquee-range-dialog {
    width: 380px;
    height: 200px;
    padding: 46px 60px 20px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
  }

  .marquee-range-title {
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #050F0F;

    span {
      color: #41B48C;
    }
  }

  .marquee-range-form {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    font-weight: bold;
    font-size: 14px;
    color: #050F0F;
  }

  .marquee-range-prefix {
    margin-right: 10px;
  }

  .marquee-range-unit {
    margin-left: 10px;
  }

  .marquee-range-select {
    width: 50px;
    height: 32px;

    /deep/ .el-input__inner {
      height: 32px;
      padding: 0 21px 0 10px;
      border: none;
      border-radius: 2px;
      background: #F2F5F5;
      font-weight: bold;
      font-size: 14px;
      line-height: 32px;
      color: #829191;
    }

    /deep/ .el-input__icon {
      width: 18px;
      line-height: 32px;
      color: #B9C3C3;
    }
  }

  .marquee-range-actions {
    display: flex;
    justify-content: space-between;
  }

  .marquee-range-btn {
    width: 120px;
    height: 32px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
    user-select: none;

    &.confirm {
      background: #41B48C;
    }

    &.cancel {
      background: #B9C3C3;
    }

    &:active {
      opacity: 0.82;
    }
  }
}
</style>

<style lang="less">
.sports-up-container {
  .broadcast-filter {
    .el-date-editor {
      input {
        height: 30px;
      }

      .el-input__prefix {
        line-height: 30px;

        i {
          line-height: 30px;
        }
      }
    }
  }
}

.marquee-range-select-popper {
  min-width: 50px !important;

  .el-select-dropdown__item {
    height: 30px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 14px;
  }

  .el-select-dropdown__item.selected {
    color: #41B48C;
  }
}
</style>
